import { render } from "./LoadingDashboardCards.vue?vue&type=template&id=a0ad6fc4"
import script from "./LoadingDashboardCards.vue?vue&type=script&lang=js"
export * from "./LoadingDashboardCards.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__